






























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  ExpenseReimbursementMethod,
  ExpenseReimbursementStatus,
  HsabExpenseResponse
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";

@Component({})
export default class HsabExpenseCardRowRepayments extends Vue {
  formatCurrency = formatCurrency;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get hasRepayments () {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.repayments
        && this.expense.reimbursement.repayments.length > 0;
  }

  get repayments () {
    return this.expense.reimbursement.repayments;
  }

  statusDisplay (status: ExpenseReimbursementStatus) {
    switch (status) {
      case ExpenseReimbursementStatus.Pending:
        return "Pending";
      case ExpenseReimbursementStatus.Scheduled:
        return "Scheduled";
      case ExpenseReimbursementStatus.Repaid:
        return "Repaid";
      case ExpenseReimbursementStatus.Cancelled:
        return "Cancelled";
    }
    return "";
  }

  methodDisplay (method: ExpenseReimbursementMethod) {
    switch (method) {
      case ExpenseReimbursementMethod.Check:
        return "Check";
      case ExpenseReimbursementMethod.Payroll:
        return "Payroll";
      case ExpenseReimbursementMethod.Provider:
        return "Provider";
      case ExpenseReimbursementMethod.ElectroncFundTransfer:
        return "Electronic Transfer";
    }
    return "";
  }
}
